export default __webpack_public_path__ + "static/media/bar-graph-border-left.aef07ee5.svg";